import { CenterContent, MainContent } from "shared/styles";
import { Spacer } from "shared/layout";
import { Card, Head, Title } from "shared/components";
import { copy } from "shared/assets";
import { Venue } from "shared/assets/icons";

import { UserVenueTable } from "Venues/pages/dashboard/containers";

const { venueOverview } = copy;

export const MyVenues = () => {
  return (
    <CenterContent>
      <Head title={venueOverview.title} />
      <Title title={venueOverview.title} isVisuallyHidden />
      <MainContent>
        <Spacer size="m">
          <Card title={venueOverview.title} icon={Venue}>
            <Spacer size="s">
              <UserVenueTable />
            </Spacer>
          </Card>
        </Spacer>
      </MainContent>
    </CenterContent>
  );
};
